import { IconComponentsProps } from './types';

const ArrowDownIcon = ({ fill = 'currentColor', ...props }: IconComponentsProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M18 9L12 16.5L6 9H18Z" fill={fill} />
  </svg>
);

export default ArrowDownIcon;
